define('app/collections/search_products',['app/setup','app/models/search_product'], function(takhfifan,searchProduct) {
  takhfifan.SearchProducts = Backbone.Collection.extend({
    model: takhfifan.SearchProduct,

    url: function() {
      var finalURL = "/catalogsearch/result/ajaxreload/";
      var params = [];

      if(this.q) {
        params.push("q=" + this.q);
      }

      if(this.order) {
        params.push("order=" + this.order);
      }

      if(this.sortOrder) {
        params.push("sortOrder=" + this.sortOrder);
      }

      if(this.limit) {
        params.push("limit=" + this.limit);
      }

      if(this.minPrice) {
        params.push("minPrice=" + this.minPrice);
      }

      if(this.maxPrice) {
        params.push("maxPrice=" + this.maxPrice);
      }

      if(this.categoryId) {
        var catArr=[];
        $.each(this.categoryId,function(idx,key){
          catArr.push(key);
        });
        params.push("categoryId=" + catArr.join());
      }

      if(this.cityId) {
        params.push("cityId=" + this.cityId);
      }

      if(this.brand) {
        var brandArr=[];
        $.each(this.brand,function(idx,key){
          brandArr.push(key);
        });
        params.push("brand=" + brandArr.join());
      }

      if(this.pageNum) {
        params.push("pageNum="+this.pageNum);
      }

      if(params.length > 0) {
        finalURL = finalURL + "?" + params.join("&");
      }
      return finalURL;
    },

    parse: function(response) {
      this.pagination = response.pagination;
      return response.models;
    }
 });
});

